/* eslint-disable*/
import VueStoreService from './VueStoreService';
const RolesService = {
    async getRoles(url,store){
        var resp = await VueStoreService.get("role"+url, store)
        return resp;
    },
    async saveRole(data,store){
        var resp = await VueStoreService.post("role",data,store)
        return resp;
    },
    async getRole(role_id,store){
        var resp = await VueStoreService.get( "role/"+role_id,store)
        return resp;
    },

    async savePermission(data,store){
        var resp = await VueStoreService.post("role/menu/",data,store)
        return resp;
    },
    async getPermission(role_id,store){
        var resp = await VueStoreService.get( "role/menu/"+role_id,store)
        return resp;
    },

    async updateRole(role_id,data,store){
        var resp = await VueStoreService.patch("role/"+role_id,data,store)
        return resp;
    },

    async getMenuRole(role_id,store){
        var resp = await VueStoreService.get("role/menu/"+role_id,store)
        return resp;
    },

    async deleteRole(role_id,store){
        var resp = await VueStoreService.delete("role/"+role_id,store)
        return resp;
    },
}

export default RolesService;